import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import 'animate.css';
import './styles/global.css';
import './App.css';

// Layout
import Layout from './components/layout/Layout';
import LoadingScreen from './components/common/LoadingScreen';

// Pages
import HomePage from './pages/home/HomePage';
import CoursesPage from './pages/courses/CoursesPage';
import CourseDetailPage from './pages/course-detail/CourseDetailPage';
import SubscriptionPage from './pages/subscription/SubscriptionPage';
import TeacherDashboard from './pages/teacher/TeacherDashboard';
import StudentsPage from './pages/teacher/StudentsPage';
import CoursesManagementPage from './pages/teacher/CoursesManagementPage';
import CoursesCodesPage from './pages/teacher/CoursesCodesPage';
import CourseCodesManager from './pages/teacher/CourseCodesManager';
import TeachersPage from './pages/teachers/TeachersPage';
import TeacherProfilePage from './pages/teachers/TeacherProfilePage';
import About from './pages/About';
import Contact from './pages/Contact';

// Auth Components
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import AdminLogin from './components/auth/AdminLogin';
import TeacherLogin from './components/auth/TeacherLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import CreateAdmin from './pages/admin/CreateAdmin';
import PrivateRoute from './components/auth/PrivateRoute';

// Profile Component
import Profile from './components/profile/Profile';

// Services
import { AuthProvider } from './contexts/AuthContext';
import StudentDashboard from './pages/student-dashboard/StudentDashboard';

// Constants
// استيراد ثوابت الأدوار
import { ADMIN, TEACHER, STUDENT } from './constants/roles';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
          {loading ? (
            <LoadingScreen minDisplayTime={3000} />
          ) : (
            <Layout>
              <Routes>
                {/* Auth Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                
                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route element={<PrivateRoute allowedRoles={[ADMIN]} />}>
                  <Route path="/admin/create" element={<CreateAdmin />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/admin/profile" element={<Profile />} />
                </Route>
                
                {/* Teacher Routes */}
                <Route path="/teacher/login" element={<TeacherLogin />} />
                <Route element={<PrivateRoute allowedRoles={[TEACHER]} />}>
                  <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
                  <Route path="/teacher/students" element={<StudentsPage />} />
                  <Route path="/teacher/courses" element={<CoursesManagementPage />} />
                  <Route path="/teacher/codes" element={<CoursesCodesPage />} />
                  <Route path="/teacher/codes-manager" element={<CourseCodesManager />} />
                  <Route path="/teacher/profile" element={<Profile />} />
                </Route>
                
                {/* Student Routes */}
                <Route element={<PrivateRoute allowedRoles={[STUDENT]} />}>
                  <Route path="/student/dashboard" element={<StudentDashboard />} />
                  <Route path="/student/profile" element={<Profile />} />
                  <Route path="/subscription/:courseId" element={<SubscriptionPage />} />
                </Route>
                
                {/* Public Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/courses" element={<CoursesPage />} />
                <Route path="/courses/:courseId" element={<CourseDetailPage />} />
                <Route path="/teachers" element={<TeachersPage />} />
                <Route path="/teacher-profile/:teacherId" element={<TeacherProfilePage />} />
                <Route path="/about-us" element={<About />} />
                <Route path="/get-in-touch" element={<Contact />} />
                
                {/* Catch all - redirect to home */}
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Layout>
          )}
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
